var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.984 5.06823C6.46206 5.49767 6.98874 5.20192 7.15484 5.02771L9.09948 2.93722V14.9778C9.09948 15.4356 9.46816 15.8043 9.92596 15.8043C10.3838 15.8043 10.7524 15.4356 10.7524 14.9778V2.93317L12.6971 5.02366C13.009 5.35992 13.5316 5.37613 13.8679 5.06417C14.2042 4.75222 14.2204 4.2296 13.9084 3.89334L10.5296 0.263337C10.3716 0.0972321 10.1528 0 9.92596 0C9.69503 0 9.47626 0.0972321 9.32231 0.263337L5.94349 3.89334C5.63154 4.23365 5.64369 4.76437 5.984 5.06823V5.06823Z",
    fill: "#CAC2C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0251 13.1289C18.5673 13.1289 18.1986 13.4976 18.1986 13.9554V18.2012H1.65295V13.9554C1.65295 13.4976 1.28427 13.1289 0.826473 13.1289C0.368672 13.1289 0 13.4976 0 13.9554V19.0277C0 19.4855 0.368672 19.8541 0.826473 19.8541H19.0251C19.4829 19.8541 19.8516 19.4855 19.8516 19.0277V13.9554C19.8516 13.4976 19.4829 13.1289 19.0251 13.1289Z",
    fill: "#CAC2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.48c830816d92d1c7599144bce44f1e23.svg";
export { ForwardRef as ReactComponent };